import { useTranslation } from 'react-i18next';
import { StatusBadge, DateTools } from '@treezor/design-system';

import { useSCAStatus } from '../hooks/useSCAStatus';

import { InfoTooltip } from '@/ui-kit/Tips/InfoTooltip';


import { IScaWallet } from '@/store/models/sca.model';

interface ISCAStatusProps {
  scaWallet: IScaWallet;
}

export function SCAStatus({ scaWallet }: ISCAStatusProps) {
  const { t } = useTranslation();
  const { scaStatusProps, scaStatus } = useSCAStatus({ scaWallet });

  return (
    <div className="flex items-center gap-3">
      <StatusBadge emphasis="low" size="s" {...scaStatusProps} />
      {scaStatus === 'LOCKED' && (
        <div className="flex items-center gap-2">
          {scaWallet?.lockReasons?.length > 0 && (
            <span className="typo-body-regular-small text-tertiary">
              {t(`pages.currentProfiles.profile.sca.lock.lockReasons.${scaWallet.lockReasons[0]}`)}
            </span>
          )}
          {scaWallet?.lockMessage && (
            <InfoTooltip tooltipInfo={scaWallet.lockMessage} className="mt-1" infoClassName="min-w-[150px]" />
          )}
        </div>
      )}
      {scaStatus === 'DELETED' && (
        <InfoTooltip
          tooltipInfo={DateTools.format(scaWallet.deletionDate, 'date-time')}
          className="mt-1"
          infoClassName="min-w-[155px]"
        />
      )}
    </div>
  );
}
